import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import Image from 'next/image';

import { getFormattedDateString } from '@/utils/string/formattedDate';
import { joinSgcmMedia, joinSgcmSite } from '@/utils/url/join/public';
import { getInternalLink } from '@/utils/url/utm';

import { CardWithAvatar } from '../card-with-avatar';
import { ICON_SIZE } from './constant';
import styles from './styles.module.scss';
import type { Component } from './types';

export const EditorialReview: Component = ({
  review,
  avatarSize,
  youtubeLink,
}) => {
  const { isIpadMini } = useScreenDetect();

  const categoryReviewLink = review ? `${joinSgcmSite(`articles/listing/car-reviews?q=${review.category}`)}` : '';

  return (
    <div>
      {
        youtubeLink && (
          <div className={styles.containerYoutube}>
            <iframe
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" // @suppress longLineCheck
              referrerPolicy="strict-origin-when-cross-origin"
              src={youtubeLink}
              title="YouTube video player" />
          </div>
        )
      }
      {
        review && (
          <CardWithAvatar
            avatar={review.editor?.img ?? null}
            avatarSize={avatarSize}
            showDivider={false}
            upperChildNode={(
              <div className={styles.containerContent}>
                <div className={styles.contentDate}>
                  <span>
                    {getFormattedDateString(
                      review.postDate,
                      'shorten',
                    )}
                    {' '}
                    •
                    {' '}
                  </span>
                  {
                    review.category && (
                      <a
                        className={styles.contentBrandReviewLink}
                        href={getInternalLink(categoryReviewLink, 'editorial')}>
                        {review.category}
                        {' '}
                        Review
                      </a>
                    )
                  }
                </div>
                <div>
                  <a
                    className={styles.contentTitle}
                    href={getInternalLink(review.link, 'editorial')}>
                    {review.title}
                  </a>
                </div>
                {
                  isIpadMini() && (
                    <div className={styles.contentDescription}>
                      {review.description}
                    </div>
                  )
                }
                <div className={styles.contentAuthor}>
                  Story by
                  {' '}
                  {review.editor?.name}
                </div>
              </div>
            )} />
        )
      }
      {
        review && review.facelift && (
          <div className={styles.containerReviewDetail}>
            <div className={styles.reviewDetailHead}>
              {' '}
              <span className={styles.reviewDetailTopic}>Facelift</span>
              {' '}
              (What&apos;s New?)
            </div>
            {
              review.facelift.map(item => (
                <div
                  key={item}
                  className={styles.reviewDetailContent}>
                  <Image
                    alt="icon image"
                    className={styles.imageThumbnail}
                    height={ICON_SIZE}
                    src={`${joinSgcmMedia('/public/new-cars/icon/starburst.svg')}`}
                    width={ICON_SIZE} />
                  <div className={styles.reviewDetailItem}>
                    {item}
                  </div>
                </div>
              ))
            }
          </div>
        )
      }
      {
        review && review.prosAndCons && (
          <div className={styles.containerReviewBlock}>
            <div className={styles.containerReviewDetail}>
              <div className={styles.reviewDetailHead}>
                <span className={styles.reviewDetailTopic}>What we like</span>
              </div>
              {
                review.prosAndCons.pros.map(item => (
                  <div
                    key={item}
                    className={styles.reviewDetailContent}>
                    <Image
                      alt="icon bold check"
                      className={styles.iconBoldCheck}
                      height={18}
                      src={`${joinSgcmMedia('/public/new-cars/icon/iconBoldCheck.svg')}`}
                      width={18} />
                    <div className={styles.reviewDetailItem}>
                      {item}
                    </div>
                  </div>
                ))
              }
            </div>
            <div className={styles.containerReviewDetail}>
              <div className={styles.reviewDetailHead}>
                <span className={styles.reviewDetailTopic}>
                  What we don’t like
                </span>
              </div>
              {
                review.prosAndCons.cons.map(item => (
                  <div
                    key={item}
                    className={styles.reviewDetailContent}>
                    <Image
                      alt="icon bold cross"
                      className={styles.iconBoldCross}
                      height={18}
                      src={`${joinSgcmMedia('/public/new-cars/icon/iconBoldCross.svg')}`}
                      width={18} />
                    <div className={styles.reviewDetailItem}>
                      {item}
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        )
      }
      {
        review && review.compare && (
          <div className={styles.containerReviewBlock}>
            {
              review.compare.map(set => (
                <div
                  key={set.car}
                  className={styles.containerReviewDetail}>
                  <div className={styles.reviewDetailHead}>
                    <span className={styles.reviewDetailTopic}>
                      {set.car}
                    </span>
                  </div>
                  {
                    set.items.map(item => (
                      <div
                        key={item}
                        className={styles.reviewDetailContent}>
                        <Image
                          alt="icon image"
                          className={styles.imageThumbnail}
                          height={ICON_SIZE}
                          src={`${joinSgcmMedia('/public/new-cars/icon/starburst.svg')}`}
                          width={ICON_SIZE} />
                        <div className={styles.reviewDetailItem}>
                          {item}
                        </div>
                      </div>
                    ))
                  }
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  );
};
